import React from "react";
import { useHistory } from "react-router-dom";

import {
  BooleanField,
  Button,
  CreateButton,
  Datagrid,
  DateField,
  EditButton,
  FunctionField,
  List,
  RefreshButton,
  SelectField,
  ShowButton,
  SimpleList,
  TopToolbar,
} from "react-admin";
import { useMediaQuery, Grid, Typography } from "@material-ui/core";

import { UrgencyOptions } from "../../../utils/constants";
import { ChevronRightIcon, EmailIcon } from "../../../components/common/iconography";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { Pagination } from "../../../components/Pagination";
import { HelpButton } from "../../../components/common/HelpButton";

const messageRender = (record) => {
  return record.message.substring(0, 50);
};

const ListActions = ({ basePath, ...props }) => {
  const history = useHistory();

  const handleOpen = (event) => {
    debugger;
    event.stopPropagation();
    event.preventDefault();
    history.push({
      pathname: `/emailAnnouncement`,
      state: { backPath: basePath },
    });
  };

  return (
    <TopToolbar>
      <HelpButton />
      <CreateButton basePath={basePath} />
      <Button label="Send Email" color="primary" onClick={handleOpen}>
        <EmailIcon />
      </Button>
      <RefreshButton />
    </TopToolbar>
  );
};

const BooleanStringField = ({ record, source, label, ...props }) => {
  record[source] = `${record[source]}` === "true";
  return (
    <BooleanField
      source={source}
      label={label}
      record={record}
      looseValue={false}
      sortable={false}
    />
  );
};

export const AnnouncementList = (props) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  return (
    <List
      {...props}
      title={<ForceTitle title="Announcements" />}
      actions={<ListActions />}
      bulkActionButtons={false}
      pagination={<Pagination />}
    >
      {isXSmall ? (
        <SimpleList
          primaryText={(record) => messageRender(record)}
          secondaryText={(record) => `Urgency: ${messageRender(record)}`}
          tertiaryText={(record) => `Create Date: ${record.createdAt}`}
          linkType="edit"
          // leftIcon={record => <UserStatusIcon record={record} />}
          rightIcon={() => (
            <ChevronRightIcon
              fontSize="large"
              color="secondary"
              style={{ marginLeft: 40, marginTop: 10 }}
            />
          )}
        />
      ) : isSmall ? (
        <Datagrid rowClick="edit">
          <BooleanStringField
            source="active"
            label="Active"
            looseValue={true}
            sortable={false}
          />
          <SelectField
            source="urgency"
            label="Urgency"
            choices={UrgencyOptions}
            sortable={false}
          />
          <FunctionField
            source="message"
            label="Message"
            render={messageRender}
            sortable={true}
          />
        </Datagrid>
      ) : (
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            align="center"
            justify="center"
            alignItems="center"
          >
            <Typography variant="h5">
              ENABLE selected announcements to make them visible on client.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Datagrid rowClick="edit">
              <BooleanStringField
                source="active"
                label="Active"
                looseValue={true}
                sortable={false}
              />
              <SelectField
                source="urgency"
                label="Urgency"
                choices={UrgencyOptions}
                sortable={false}
              />
              <DateField
                source="createdAt"
                label="Create Date"
                sortable={false}
              />
              <FunctionField
                source="message"
                label="Message"
                render={messageRender}
                sortable={true}
              />
              <ShowButton />
              <EditButton />
            </Datagrid>
          </Grid>
        </Grid>
      )}
    </List>
  );
};
